module.exports = __webpack_public_path__ + "img/2.a37dc3fa.png";